import React, { useEffect, useState } from "react";
import { Card, Chip, Tooltip } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import { CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import MUICustomTabs from "../../components/MUICustomTabs";
import BasicBreadcrumbs from "../../components/GeneralComponents/BreadCrumbs";
import TransactionsListProfile from "./TransactionsListProfile";
import SubscriptionListProfile from "./SubscriptionListProfile";
import { _Get_Customer_ById } from "../../DAL/Listing/UserListing";
import { _Customer_Detail_With_Subscription_Transaction_List } from "../../DAL/Listing/TransactionList";
import CustomCircularProgress from "../../components/CustomCircularProgress";
import { picBaseUrl } from "../../config/config";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

const MemberProfileNew = () => {
  const params = useParams();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [data, setData] = useState({});
  const [subscription, setSubscription] = useState([]);
  const [transaction, setTransaction] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [initialLoad, setInialLoad] = useState(true);

  const TABS_OPTIONS = [
    {
      title: "Subscriptions",
      component: (
        <SubscriptionListProfile
          subscription={subscription}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          totalPages={totalPages}
          pageCount={pageCount}
          totalCount={totalCount}
          setRowsPerPage={setRowsPerPage}
          setPageCount={setPageCount}
        />
      ),
    },
    {
      title: "Subscription's Transactions",
      component: (
        <TransactionsListProfile
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          totalPages={totalPages}
          pageCount={pageCount}
          totalCount={totalCount}
          setRowsPerPage={setRowsPerPage}
          setPageCount={setPageCount}
          transaction={transaction}
        />
      ),
    },
  ];

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
    let statusTab;
    if (newValue === 0) {
      statusTab = "subscription";
    } else {
      statusTab = "transaction";
    }
    GetUser(statusTab);
  };

  const BreadCrumbsList = [
    {
      title: "User Management",
      navigation: "/user-management",
      active: false,
    },
    {
      title: `User Profile`,
      navigation: "",
      status: "Active",
    },
  ];

  const GetUser = async (tabVlaue) => {
    const formData = {
      user_id: params.id,
      type: tabVlaue || "subscription",
    };
    initialLoad ? setInialLoad(true) : setIsLoading(true);
    const response = await _Customer_Detail_With_Subscription_Transaction_List(
      formData,
      page,
      rowsPerPage
    );
    if (response.code === 200) {
      if (tabVlaue === "subscription") {
        setPageCount(response?.data?.total_ages);
        setTotalCount(response?.data?.total_count);
        setSubscription(response?.data?.subscription);
      } else if (tabVlaue === "transaction") {
        setPageCount(response?.data?.total_ages);
        setTotalCount(response?.data?.total_count);
        setTransaction(response?.data?.transaction);
      }
      if (initialLoad) {
        setData({
          ...response?.data?.customer,
        });
      }
      setIsLoading(false);
      setInialLoad(false);
    } else {
      setIsLoading(false);
      setInialLoad(false);
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };

  const getTabValue = (value) => {
    if (value === 0) {
      return "subscription";
    } else {
      return "transaction";
    }
  };

  useEffect(() => {
    const tab = getTabValue(tabValue);
    GetUser(tab);
  }, [page, rowsPerPage]);
  // console.log(data, "data data data data ");

  if (initialLoad === true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <div className="container-fluid">
      <div className="row ">
        <div className="col-12 mb-3">
          <BasicBreadcrumbs items={BreadCrumbsList} />
        </div>
        <div className="col-12 mt-3 user-profile-detail">
          <Card
            style={{
              border: "2px solid #bebebe21",
            }}
          >
            <div className="row mb-4 mx-3 mt-3 justify-content-center align-items-center user-profile-data">
              <div className="col-12 col-md-7 d-flex align-items-center">
                <img
                  className="rounded-circle"
                  height="75px"
                  width="75px"
                  style={{
                    objectFit: "cover",
                  }}
                  src={picBaseUrl + data.profile_image}
                  alt="Profile"
                />
                <div className="ms-3">
                  <h2>{`${data.first_name || "N/A"} ${
                    data.last_name || ""
                  }`}</h2>
                  <div className="text-muted">
                    {data.user_id?.email || "N/A"}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-5 d-flex justify-content-end"></div>
            </div>
            <div className="row mx-3 mt-3 mb-5 user-profile-data">
              <div className="col-5 col-md-6 col-lg-3 mb-3">
                <h6>Phone Number:</h6>
              </div>
              <div className="col-7 col-md-6 col-lg-3 text-muted">
                {data.contact_number || "N/A"}
              </div>

              <div className="col-5 col-md-6 col-lg-3 mb-3">
                <h6>City:</h6>
              </div>
              <div className="col-7 col-md-6 col-lg-3 text-muted">
                {data.city || "N/A"}
              </div>

              <div className="col-5 col-md-6 col-lg-3 mb-3">
                <h6>State:</h6>
              </div>
              <div className="col-7 col-md-6 col-lg-3 text-muted">
                {data.state || "N/A"}
              </div>

              <div className="col-5 col-md-6 col-lg-3 mb-3">
                <h6>Country:</h6>
              </div>
              <div className="col-7 col-md-6 col-lg-3 text-muted">
                {data.country?.label || "N/A"}
              </div>

              {/* Address field spanning more space */}
              <div className="col-5 col-md-6 col-lg-3 mb-3">
                <h6>Address:</h6>
              </div>
              <div className="col-7 col-md-6 col-lg-6 text-muted">
                {data.street || "N/A"}
              </div>
            </div>
          </Card>
        </div>
        <div className="col-12 mt-3">
          {isLoading ? (
            <CustomCircularProgress />
          ) : (
            <MUICustomTabs
              data={TABS_OPTIONS}
              value={tabValue}
              handleChange={handleChangeTab}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default MemberProfileNew;
